<div class="publish-to-catalogue-container">
  <div 
    class="employee-visibility-container"
    *ngIf="isCourse"
  >
    <app-employee-visibility
      [isCourse]="isCourse"
      [isPrivatePublishing]="false"
      
      [visibilityMode]="visibilityMode"
      (visibilityModeChange)="onVisibilityModeChanged($event)"

      [organizationUnitIds]="organisationUnitIds"
      (organizationUnitIdsChange)="onOrganisationUnitIdsChanged($event)"

      [trainingGroupIds]="trainingGroupIds"
      (trainingGroupIdsChange)="onTrainingGroupIdsChanged($event)"

      [organizationUnits]="organizationUnits"
      [trainingGroups]="trainingGroups"
      [employeeCount]="personCount"
      [isViewMode]="isViewMode"
    ></app-employee-visibility>
  </div>
  <hr>
  <div class="catalogue-container">
    <div class="catalogue-title">
      {{ 'CATALOGUE.TITLE' | translate }}
    </div>

    <div
      class="catalogue-text"
      [innerHTML]="'CATALOGUE.CHOOSE-CATEGORY-MANDATORY' | translate"
    ></div>

    <div class="training-categories-container">
      <dx-drop-down-box
        [(value)]="trainingCategoryIds"
        [inputAttr]="{ 'aria-label': 'Owner' }"
        valueExpr="id"
        displayExpr="name"
        [label]="('COMMON.FIELDS.TRAINING-CATEGORIES' | translate) + ' *'"
        [dataSource]="trainingCategories"
        [readOnly]="isViewMode"
        labelMode="floating"
        stylingMode="outlined"
      >
        <dx-validator validationGroup="customFields">
          <dxi-validation-rule
            type="required"
            [message]="'VALIDATIONS.TRAINING-CATEGORY-REQUIRED' | translate"
          ></dxi-validation-rule>
        </dx-validator>
        <div *dxTemplate="let data of 'content'">
          <dx-tree-view
            [searchEnabled]="true"
            [dataSource]="trainingCategories"
            dataStructure="plain"
            keyExpr="id"
            selectionMode="multiple"
            showCheckBoxesMode="normal"
            [selectNodesRecursive]="false"
            displayExpr="name"
            [selectByClick]="true"
            (onItemSelectionChanged)="onTrainingCategorySelected($event)"
          ></dx-tree-view>
        </div>
      </dx-drop-down-box>
    </div>

    @if (trainingCategoryIds.length === 0) {
      <div class="info-container category-required-container">
        <i
          class="dx-icon dx-svg-icon"
          [innerHTML]="getWarningIcon()"
        ></i>
        <span
          [innerHTML]="'CATALOGUE.TRAINING-CATEGORY-REQUIRED' | translate"
        ></span>
      </div>
    } @else {
      <div class="info-container training-catalogue-container">
        <i
          class="dx-icon dx-svg-icon"
          [innerHTML]="getBookIcon()"
        ></i>
        <span [innerHTML]="getTrainingCatalogueText()"></span>
      </div>
    }
  </div>
</div>